import { api } from "@/api";
const supplierStore = {
  state: {
    suppliers: [],
    dueTimes: ["7 jours", "14 jours", "30 jours", "autre"]
  },
  getters: {
    getSuppliers(state) {
      return state.suppliers;
    },
    getDueTimes(state) {
      return state.dueTimes;
    }
  },
  mutations: {
    setSuppliers(state, value) {
      state.suppliers = value;
    },
    addSupplier(state, value) {
      state.suppliers.push(value);
    }
  },
  actions: {
    async loadSuppliers(context) {
      const res = await api.getSuppliers();
      context.commit("setSuppliers", res);
    },
    async addSupplier(context, payload) {
      const res = await api.postSupplier(payload);
      context.commit("addSupplier", res);
    }
  }
};

export default supplierStore;
